<template>
  <div class="v-autocomplete" :class="{
    'v-autocomplete--has-value': model
  }" data-vv-value-path="model" :data-vv-as="label" :id="name">
    <div class="v-autocomplete__input">
      <div class="v-input" :class="{
        'v-input--is-focus': showList,
        'v-input--is-dirty': !!phrase,
        'v-input--is-disabled': disabled,
        'v-input__error--border': !!errors.has(newName) && !phrase || !!errors.has(newName) && isDirtyData
      }">
        <label class="v-input__label" v-if="label">
          {{ label }}
        </label>
        <input type="hidden" :name="name" :value="model" :rules="rules">
        <input class="v-input__field"
               v-model="phrase"
               type="text"
               :name="`_labels[${name}]`"
               autocomplete="off"
               @input="suggest($event)"
               @keyup.up="suggest($event)"
               @keyup.down="suggest($event)"
               @keydown.enter.prevent="suggest($event)"
               @keydown="clearTimeout"
               @focus="showList = true"
               :disabled="disabled"
               @blur="blur"
               ref="autocomplete">
        <v-modal-link :href="`${base}/create?autocomplete=true&name=${name}`" v-if="base!=='' && showCreate" style="position: absolute; top: 3px; right: 35px; width: 25px; height: 100%;">
          <i class="material-icons" style="padding-top: 15px;">add</i>
        </v-modal-link>
        <v-modal-link :href="`${base}/edit/${model}`+(extraParams!==''?'?'+extraParams:'')" v-if="base=='/admin/management/locations' && model && (!initialItem || (!item && initialItem && (!initialItem.source || initialItem.source!='uploaded')) || (item && (!item.source || item.source!='uploaded')))" style="position: absolute; top: 3px; right: 0; width: 25px; height: 100%;">
          <i class="material-icons" style="padding-top: 15px;">search</i>
        </v-modal-link>
        <v-modal-link :href="`${base}/${model}/edit`+(extraParams!==''?'?'+extraParams:'')" v-else-if="base!=='' && model && (!initialItem || (!item && initialItem && (!initialItem.source || initialItem.source!='uploaded')) || (item && (!item.source || item.source!='uploaded')))" style="position: absolute; top: 3px; right: 0; width: 25px; height: 100%;">
          <i class="material-icons" style="padding-top: 15px;">search</i>
        </v-modal-link>
        <v-modal-link :href="`${base}/buying/${model}/edit`+(extraParams!==''?'?'+extraParams:'')" v-else-if="base!=='' && model && ((initialItem && (!initialItem.source || initialItem.source=='uploaded')) || (item && item.source && item.source=='uploaded'))" style="position: absolute; top: 3px; right: 0; width: 25px; height: 100%;">
          <i class="material-icons" style="padding-top: 15px;">search</i>
        </v-modal-link>
        <i class="material-icons" v-else style="position: absolute; top: 3px; right: 0; width: 25px; height: 100%; padding-top: 15px;">search</i>
        <div v-if="!!errors.has(newName) && !phrase || !!errors.has(newName) && isDirtyData" class="v-input__error">
          {{ errors.first(newName) }}
        </div>
      </div>

      <ul class="v-autocomplete__list" v-show="showList" ref="autocompleteList">
        <li v-for="(item) in suggestions"
            :class="['v-autocomplete__item',
                    item === selected ? 'v-autocomplete__item--is-selected' : '']"
            :key="item.id"
            @click="pick(item, false)"
            v-html='resolve(item)'>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import field from '../mixins/field'
  import $ from 'jquery'
  import VModalLink from './VModalLink.vue';

  export default {
    components: {
      VModalLink
    },
    props: {
      value: {
        default() { return [] }
      },
      resolve: {
        default: (hit) => {
          return hit.name
        },
        type: Function
      },
      endpoint: {
        default: '/admin/autocomplete/locations',
        type: String
      },
      base: {
        default: '',
        type: String
      },
      id: {
        default: '',
        type: String
      },
      initial: {
        default: "",
        type: String
      },
      initialItem: {
        default: null,
        type: Object, String
      },
      extraParams: {
        default: "",
        type: String
      },
      showCreate: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        isDirtyData: null,
        showList: false,
        suggestions: [],
        selected: null,
        phrase: this.initial,
        picked: { 'id': this.model, 'name': this.initial },
        typingTimer: null,
        item: null,
        doneTypingInterval: 700,
        doSubmit: false
      }
    },
    mounted() {
      this.selectAllData();
    },
    methods: {
      suggest(event) {
        let keyCode = event.keyCode;
        if (keyCode === 38) {
          if (_.indexOf(this.suggestions, this.selected) === 0) {
            this.selected = this.suggestions[this.suggestions.length - 1]
          } else {
            this.selected = this.suggestions[_.indexOf(this.suggestions, this.selected) - 1]
          }

          this.scrollIntoView(event);
        }

        else if (keyCode === 40) {
          if (_.indexOf(this.suggestions, this.selected) === this.suggestions.length - 1) {
            this.selected = this.suggestions[0]
          } else {
            this.selected = this.suggestions[_.indexOf(this.suggestions, this.selected) + 1]
          }

          this.scrollIntoView(event);
        }

        else if (keyCode === 13) {
          this.pick(this.selected, true);
        }

        else {
          this.typing();
        }
      },
      pick(item, doSubmit) {
        this.phrase = this.resolve(item);
        this.picked = { 'id': item.id, 'name': this.phrase };
        this.showList = false;
        this.model = item.id;
        this.item = item;
        this.selected = null;
        this.isDirtyData = false;
        if (doSubmit) this.doSubmit = true;
      },
      typing() {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);

        this.showList = true;
        this.model = this.phrase;
        this.isDirtyData = true;
      },
      clearTimeout() {
        clearTimeout(this.typingTimer);
      },
      doneTyping() {
        $.get(this.endpoint + '?q=' + this.phrase).then((response) => {
          this.suggestions = response;
        }).catch(() => {
          // A failed lookup must not leave a stale suggestions list showing under the still-open
          // v-show="showList" dropdown, and must never touch model/picked/item - the previously
          // selected value (if any) stays exactly as it was.
          this.suggestions = [];
        })
      },
      changePhrase(value, id) {
        this.phrase = value;
        this.model = id;
      },
      addNewItem(item) {
        let list = this.$refs.autocompleteList;

        this.suggestions.push(item);

        setTimeout(function () {
          if (list.querySelectorAll('li').length) {
            list.querySelectorAll('.v-autocomplete__item')[list.querySelectorAll('li').length - 1].click();          
          }
        }, 700);
      },
      blur() {
        setTimeout(() => { this.showList = false }, 300)
      },
      scrollIntoView: function (event) {
        let offset,
          scroll,
          elementHeight,
          itemHeight,
          list = $(event.target).parents('.v-autocomplete__input').find('.v-autocomplete__list'),
          item = list.find('.v-autocomplete__item--is-selected');

        if (item.length && list.outerHeight() < list.prop("scrollHeight")) {
          offset = item.offset().top - list.offset().top;
          scroll = list.scrollTop();
          elementHeight = list.height();
          itemHeight = item.outerHeight() * 2;

          if (offset < 0) {
            list.scrollTop(scroll + offset);
          }
          if (offset + itemHeight > elementHeight) {
            list.scrollTop(scroll + offset - elementHeight + itemHeight);
          }
          if (item.is(':last-child')) {
            list.scrollTop(0);
          }
        }
      },
      selectAllData() {
        const selector = this.$refs.autocomplete;

        selector.addEventListener("focus", function () {
          selector.select();
        });
      }
    },
    mixins: [field],
    watch: {
      model(value) {
        if (!value) {
          this.phrase = null;
        }

        this.$emit('update', value)
        this.$emit('input', value);
      },
      phrase(value) {
        this.$emit('phrase', value);
      },
      picked(value) {
        this.$emit('picked', value);
      },
      doSubmit() {
        this.$emit('submit');
      }
    }
  }
</script>